import { CssVarsThemeOptions } from '@mui/material/styles'

// ----------------------------------------------------------------------

export function dialog(): CssVarsThemeOptions['components'] {
	return {
		MuiDialog: {
			styleOverrides: {
				paper: ({ theme, ownerState }) => ({
					boxShadow: theme.customShadows.dialog,
					borderRadius: theme.shape.borderRadius * 2,
					...(!ownerState.fullScreen && {
						margin: theme.spacing(2),
					}),
				}),
				paperFullScreen: {
					borderRadius: 0,
				},
			},
		},
		MuiDialogTitle: {
			styleOverrides: {
				root: ({ theme }) => ({
					padding: theme.spacing(3, 4, 4, 4),
				}),
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: ({ theme }) => ({
					padding: theme.spacing(4),
					overflowY: 'visible',
				}),
				dividers: ({ theme }) => ({
					borderTop: 0,
					borderBottomStyle: 'dashed',
					padding: theme.spacing(4),
				}),
			},
		},
		MuiDialogActions: {
			styleOverrides: {
				root: ({ theme }) => ({
					padding: theme.spacing(4),
					'& > :not(:first-of-type)': {
						marginLeft: theme.spacing(1.5),
					},
				}),
			},
		},
	}
}
